const OPTIONS = { threshold: 0.15, rootMargin: '0px 0px -50px 0px' };

export function initReveal(root = document) {
  if (!('IntersectionObserver' in window)) {
    root.querySelectorAll('.reveal').forEach((el) => el.classList.add('in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    }
  }, OPTIONS);
  root.querySelectorAll('.reveal').forEach((el) => io.observe(el));
}
